import WizardHeading from 'components/customComponents/Controls/WizardHeading';
import WizardParagraph from 'components/customComponents/Controls/WizardParagraph';
import React, { useContext, useEffect, useState } from 'react';
import ScreenWizardContext from './ScreenWizardContext';
import WizardCreateExpButton from './WizardCreateExpButton';
import './ScreenExperimentWizard.scss';
import { isNullOrUndefined } from 'utils/Global';
import LayersError from 'components/customComponents/Layers/LayersError';
import useRockFetchGet from 'utils/RockFetch';

function TemplateName({
  changeContentView,
  setDisableSaveSetup,
  setIsSetupSave,
  setSaveAsDisabled,
  title,
}: any) {
  const MAX_NAME_LENGTH = 25;
  const screenExpContext = useContext(ScreenWizardContext);
  const [templateNamesList, setTemplateNamesList] = useState([]);
  const [templateName, setTemplateName] = useState('');
  const [duplicateTemp, setDuplicateTemp] = useState(false);
  const [rockFetchGet] = useRockFetchGet();
  useEffect(() => {
    async function fetchTemplates() {
      const response: string[] = await rockFetchGet(
        '/api/ScreenExpWizard/templatenames',
        'get',
        undefined,
        true,
      );
      if (response != null) {
        setTemplateNamesList(response);
      }
    }
    fetchTemplates();
  }, []);

  function onChange(evt) {
    const val = evt.target.value;
    if (val.length > MAX_NAME_LENGTH) {
      return;
    }
    setTemplateName(val);
    const tempName = templateNamesList.find((name) => name === val);
    if (!isNullOrUndefined(tempName)) {
      setDuplicateTemp(true);
    } else {
      setDuplicateTemp(false);
    }
  }

  async function saveTemplate(teplateName) {
    const isSaved = await screenExpContext.saveScreenExpTemplate(teplateName);
    if (isSaved != null) {
      setIsSetupSave(isSaved);
    }
    setDisableSaveSetup(true);
    setSaveAsDisabled(false);
    changeContentView();
  }
  return (
    <div
      id='templatename-wrapper'
      className={
        duplicateTemp ? 'template-name-container-extended' : 'template-name-container'
      }
    >
      <WizardHeading text={title} style={{ justifyContent: 'flex-start' }} />
      <WizardParagraph
        text="You may save the wizard setup for future use. Please provide the name of current setup in the textbox below."
        customStyle={{ textAlign: 'start' }}
      />
      <div id='templatename-labelrow' className="flex">
        <label
          id="templatename-label"
          style={{
            fontSize: '13px',
            lineHeight: '15px',
            display: 'flex',
            alignItems: 'center',
            flex: 1,
            color: '#000000',
          }}
        >
          Setup Name:
        </label>
        <div
          id="templatename-charlimit"
          style={{
            fontSize: '11px',
            lineHeight: '13px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            textAlign: 'right',
            color: '#C6C6C6',
            flex: 1,
          }}
        >
          {`Maximum 25 characters (${MAX_NAME_LENGTH - templateName.length} remaining)`}
        </div>
      </div>
      <input
        id="templatename-input"
        type="text"
        style={{
          width: '100%',
          outline: 'none',
          border: 'none',
          fontSize: '13px',
          lineHeight: '15px',
          marginTop: '21px',
          color: '#333333',
        }}
        placeholder="Enter setup name here"
        value={templateName}
        onChange={onChange}
      />
      <hr id="templatename-divider" style={{ background: '#F7A246', margin: '0px' }} />
      {duplicateTemp && (
        <LayersError
          errorText="The setup name you’ve entered already exist, try something else!"
          style={{ marginTop: '10px' }}
        />
      )}
      <div
        id="templatename-buttonrow"
        className="flex"
        style={{
          width: '100%',
          justifyContent: 'center',
          marginTop: '25px',
          alignSelf: 'flex-end',
        }}
      >
        <WizardCreateExpButton
          id="templatename-savebutton"
          onClick={() => saveTemplate(templateName)}
          text="Save"
          disabled={templateName.length === 0 || duplicateTemp}
        />
        <div id="templatename-buttonspacer" style={{ width: '13px' }}></div>
        <WizardCreateExpButton id="templatename-cancelbutton" onClick={changeContentView} text="Cancel" />
      </div>
    </div>
  );
}

export default TemplateName;
